/* globals google */
'use strict';

const MarkerClusterer = require('@google/markerclusterer');
const pagination = require('../util/pagination');
const googleHelper = require('../../js/components/googleHelper');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 * @param {Object} location - Response from the server
 */
function maps(location) {
    var map;
    var markerClusterer;
    var markers = [];
    var infowindow = new google.maps.InfoWindow();
    var markerImageUrl = 'data:image/png;base64,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';
    var markerImageUrlAlt = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANgSURBVHgB1ZtPTlNRFMa/+1oTnDF02BFTugPrzERIcAePFYgrEHeAK+CxApugJo547qDMjKO6A4bG0Hc951UajNByzz333MsvIXRC6Tvf7/6/dTBgqz4Y/cbigF7uevgx4LeBanv5+wY/B9wVvZg74LIC2uvmU4vEOKSiPtiucP2GHrimfzOCCHdFH3BawZ+lKoZ+AVYP7o7+TTia1mN4iGY6hyIDKDKo90lzf0EvX9LPFnQZOXRH1XgHfvbjG5RQM6Cq99554Bg2zMiG1xo2qBSgql+dkvI1THFzj8GL2CJUiGSZvPXDM56axPVH7nMQQVQfQG2+Ju1PkI9nNEJsUZ/wFULkTYDGdofFBSeBzFAI1BRkw+QQQiosSH3Zw3en5/e/7+E+QqEUuQNuIUDWB1D6ywlOMUxQ700gQFQATh+FwRZAgKgAniteHmPJiBBcgGGvWv6O7w7o4RcTBBJcgA5ujEKhIXGCQIILQPo/R6FIRiVBH1Ck/n+pdhGIYB7gRr0Ha1g3zm9i09+unyfYGKC5xs9O9GLosSMoQL9vVyrBn01QgK7kAswRiKAA1QzF4n8ikOACOPhLFIoTrAiDh8GO/smmhcemJa32cnj1vvAtAglvAv3GQ4kdoZuj+RLcPEXDIDWDDygMmpq9hwBRAToMT8qygNM/byBANhFqplclWSBNnxHPBMuxQJ4+I58KF2JBTPpM1FogvwVx6ffvgEjoZOjYCzckY6ENkLdoPkcdzESvBvNZQOnjyRSRxC+HM/UFlP6Zxumwyn6AvQWc/rCBAjobIsYW9IsepZsiajtClhZ0GEQNfbfR2xIzssDBNZr3hFT3BC0s0Eyf0d0UTWyBdvqM+q5wSgu002f0t8UTWZAifSbJuUAKC1Kkz6Q5GFG2IFX6TLKTIU0LUqXPpDsaU7IgZfpM0rNBDQtSps+kPRyNt6BNmT6T/HQ4xoLY7a6HkP54XG5BC4NvjJjcD5BYYJE+Y3NBItwCk/QZsxsiIRZ4uDMYofqVmbXMvv+qxjtPsfGWab/VfQgjTO8IPcQCq7Z/g50BzEYLbNNnzG+JrbPAOn3G1gDmXgvs02ey3BO8y4Ic6TP2BjD/WZAnfSbbTdHbFuRKn8ljALOywI1ypc+IvzWmwdKCRdaLl38ACzdRqTogJfoAAAAASUVORK5CYII=';
    var markerClustererImageUrl = 'data:image/png;base64,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';

    // Init EU map in the center of the viewport
    var latlng = new google.maps.LatLng(50.508635, 3.8488281);
    var mapOptions = {
        scrollwheel: false,
        zoom: 7,
        maxZoom: 17,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: true,
        mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_RIGHT
        }
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');
    var bounds = new google.maps.LatLngBounds();
    var alternativeMap = $('.map-canvas').hasClass('map-alt');

    if (mapdiv) {
        mapdiv = JSON.parse(mapdiv);
        Object.keys(mapdiv).forEach(function (key) {
            var item = mapdiv[key];
            var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
            var marker = new google.maps.Marker({
                position: storeLocation,
                map: map,
                title: item.name,
                icon: alternativeMap ? markerImageUrlAlt : markerImageUrl
            });

            marker.addListener('click', function () {
                infowindow.setOptions({
                    content: item.infoWindowHtml
                });
                infowindow.open(map, marker);
            });

            // Create a minimum bound based on a set of storeLocations
            bounds.extend(marker.position);

            // Add marker to array to use with cluster
            markers.push(marker);
        });
    }

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        if (location) {
            map.setCenter(location);
            map.setZoom(11);
        } else {
            map.fitBounds(bounds);
        }
    }
    var markerClustererStyles = [
        {
            textColor: '#ffffff',
            textSize: 16,
            url: markerClustererImageUrl,
            height: 40,
            width: 40
        }
    ];
    markerClusterer = new MarkerClusterer(map, markers);
    markerClusterer.setStyles(markerClustererStyles);
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 * @param {Object} location - Response from the server
 */
function updateStoresResults(data, location) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.storesLength > 0;
    var shouldHavePagination = data.storesLength > 4;

    if ($resultsDiv.data('has-pagination') === true) {
        pagination.removePagination();
    }

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps(location);
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
        if (shouldHavePagination) {
            if ($('.map-canvas').hasClass('map-alt')) {
                pagination.addPagination(8, 'storeContainer');
            } else {
                pagination.addPagination(4, 'storeContainer');
            }
            $resultsDiv.data('has-pagination', true);
        } else {
            $resultsDiv.data('has-pagination', false);
        }
        var $storeLocatorHero = $('.storeLocatorFields');
        if ($storeLocatorHero) {
            $storeLocatorHero[0].scrollIntoView({ behavior: 'smooth' });
        }
    }
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if ($('.js-store-locator-load').length) {
            var url = $('.js-store-locator-load').data('fetch-stores');
            $.ajax({
                type: 'get',
                url: url,
                success: function (data) {
                    updateStoresResults(data);
                },
                error: function () {
                    // alert('error');
                }
            });
        }
    },
    detectLocation: function () {
        var geolocationTimer;
        // clicking on detect location.
        $('.detect-location').on('click', function (e) {
            e.preventDefault();
            var $form = $(e.target).closest('.store-locator');
            var options = {
                showOnlyGuardedStores: $form.find('#storeLocatorSearchShowOnlyGuardedStores').is(':checked')
            };

            googleHelper.detectStores($form, options, (content) => {
                $('.store-locator-search-fas').find('.fa-chevron-down, .fa-chevron-up').toggleClass('fa-chevron-down fa-chevron-up');
                $('#storeLocatorSearch').collapse('hide');
                updateStoresResults(content);
                $('.select-store').prop('disabled', true);
            }, () => {
                $('#toast-geolocation').show();
                if (geolocationTimer) {
                    clearTimeout(geolocationTimer);
                }
                geolocationTimer = setTimeout(function () {
                    $('#toast-geolocation').hide();
                }, 5000);
            });
        });
    },
    search: function () {
        $('.store-locator-container .btn-storelocator-search').on('click', function (e) {
            e.preventDefault();
            var $form = $(this).closest('.store-locator');

            googleHelper.searchStores($form, {}, (resultData, location) => {
                $('.store-locator-search-fas').find('.fa-chevron-down, .fa-chevron-up').toggleClass('fa-chevron-down fa-chevron-up');
                $('#storeLocatorSearch').collapse('hide');
                updateStoresResults(resultData, location);
                $('.select-store').prop('disabled', true);
            });
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    },
    makeFavoriteStore: function () {
        $(document).on('click', '.store__set-favorite', (function () {
            let $this = $(this);

            let url = $this.data('action');

            let urlParams = {
                storeID: $this.data('store-id')
            };
            url = appendToUrl(url, urlParams);

            $.ajax({
                type: 'post',
                url: url,
                success: function () {

                },
                error: function () {
                    // alert('error');
                }
            });
        }));
    },
    toggleFas: function () {
        $('.store-locator-search').on('click', function () {
            $(this).find('.fa-chevron-down, .fa-chevron-up').toggleClass('fa-chevron-down fa-chevron-up');
        });
    }
};
